import styled from 'styled-components';

import { COLORS, EMAIL, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

// The shell (backdrop, panel, portal, close X, header divider, the 560px width) comes from the
// shared <Sheet>. What follows is only the sheet's own content, the house activation-sheet shape
// written for this scenario: the rich header, the two payment options, the total row and the error
// line.

// --- Header ---------------------------------------------------------------------------------

export const HeaderId = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[16]};
  min-width: 0;
`;

export const IconTile = styled.div`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: ${EMAIL.accentSoft};
  color: ${EMAIL.accent};
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  min-width: 0;
`;

export const Name = styled(Text)`
  font-size: 24px;
  color: ${COLORS.textSubtle};
  white-space: nowrap;
`;

export const Price = styled(Text)`
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  color: ${COLORS.textBrightest};
`;

// --- Payment options ------------------------------------------------------------------------

export const OptionCard = styled.div`
  border-radius: 16px;
  background: ${COLORS.surfaceFaint};
  overflow: hidden;
`;

export const OptionRow = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${SPACE[12]};
  width: 100%;
  padding: ${SPACE[16]};
  border: none;
  background: none;
  text-align: left;
  font-family: inherit;
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(p) => (p.$disabled ? 0.45 : 1)};

  &:disabled {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: -2px;
  }
`;

export const Radio = styled.span<{ $selected: boolean }>`
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border: ${(p) => (p.$selected ? 'none' : `1.5px solid ${COLORS.radioBorder}`)};
  background: ${(p) => (p.$selected ? COLORS.ctaPillBorder : 'transparent')};
`;

export const OptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[2]};
  min-width: 0;
`;

export const OptionLabel = styled(Text)`
  font-size: 13px;
  color: ${COLORS.optionLabel};
`;

export const OptionHint = styled(Text)<{ $warn?: boolean }>`
  font-size: 11px;
  color: ${(p) => (p.$warn ? COLORS.warning : COLORS.optionHint)};
`;

// --- Footer ---------------------------------------------------------------------------------

export const TotalRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACE[16]};
  padding: ${SPACE[16]} ${SPACE[16]} 0;
`;

export const TotalLabel = styled(Text)`
  font-size: 22px;
  line-height: 24px;
  color: ${COLORS.featureName};
`;

export const TotalValue = styled.span`
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  color: ${COLORS.onAccent};
`;

/** A settlement that failed: said IN the sheet, where the operator is looking, never as a toast. */
export const ErrorLine = styled.span`
  display: block;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  color: ${COLORS.danger};
`;
